<ng-container>
    <div class="questions-preview">
        <ng-container *ngIf="interviewQuestions?.length > 0">
            <ui-card
                [class.secondary-variant]="isSecondaryVariant"
                *ngFor="let interviewQuestion of interviewQuestions; let index = index"
            >
                <div class="app-grid">
                    <div id="question-title-{{ index }}" class="question-title columns-12 margin-bottom-1">
                        {{ index + 1 }}.
                        <span [class.bold-titles]="isSecondaryVariant"
                            >{{ interviewQuestion.question }}{{ interviewQuestion.isRequired ? '*' : '' }}
                        </span>
                    </div>
                    <div class="columns-12" [class.margin-left-3]="isMarginSetOnInterviewQuestion(interviewQuestion)">
                        <!-- Open Question -->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.openQuestion
                            "
                        >
                            <mat-form-field class="no-top-padding open-question-textarea">
                                <textarea
                                    rows="9"
                                    matInput
                                    attr.aria-labelledby="question-title-{{ index }}"
                                ></textarea>
                            </mat-form-field>
                        </ng-container>

                        <!-- Yes / No -->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name === applicantInterviewQuestionTypes.yesNo
                            "
                        >
                            <mat-radio-group class="vertical" attr.aria-labelledby="question-title-{{ index }}">
                                <mat-radio-button value="yes">{{ 'yes' | appTranslate }}</mat-radio-button>
                                <mat-radio-button value="no">{{ 'no' | appTranslate }}</mat-radio-button>
                            </mat-radio-group>
                        </ng-container>

                        <!-- Multiple Choice-->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.multipleChoice
                            "
                        >
                            <app-job-posting-interview-multiple-choice-preview
                                [interviewQuestion]="interviewQuestion"
                                aria-labelledby="question-title-{{ index }}"
                            ></app-job-posting-interview-multiple-choice-preview>
                        </ng-container>

                        <!-- Opinion Scale-->
                        <ng-container
                            *ngIf="
                                interviewQuestion.interviewQuestionType?.name ===
                                applicantInterviewQuestionTypes.opinionScale
                            "
                        >
                            <app-job-posting-interview-opinion-scale-preview
                                [interviewQuestion]="interviewQuestion"
                                [isSecondaryVariant]="isSecondaryVariant"
                                aria-labelledby="question-title-{{ index }}"
                            ></app-job-posting-interview-opinion-scale-preview>
                        </ng-container>
                    </div>
                </div>
            </ui-card>
        </ng-container>
    </div>

    <ui-card class="questions-empty-preview" *ngIf="interviewQuestions.length === 0">
        <div>{{ 'applicant-tracker.onceQuestionsHaveBeenAdded' | appTranslate }}</div>
    </ui-card>
</ng-container>
